import { jsx as e, jsxs as d } from "react/jsx-runtime";
import i from "./index.es5664.js";
import p from "classnames";
import { CellAdditionalInfoWrapper as C } from "./index.es731.js";
import { ColorIndicator as f } from "./index.es32.js";
import { BaseHeader as c } from "./index.es5578.js";
const h = "color-indicator-header", H = ({
  entityColor: m,
  colorIndicator: r,
  displayName: t,
  gridDensity: s,
  testId: o = h,
  additionalInfo: a,
  ...n
}) => {
  const l = p(i.root, i[s]);
  return /* @__PURE__ */ e(c, { displayName: t, testId: o, ...n, children: /* @__PURE__ */ d("div", { className: l, "data-testid": o + "-container", children: [
    /* @__PURE__ */ e(
      f,
      {
        entityColor: (r == null ? void 0 : r.entityColor) || m,
        testId: o + "-color-indicator",
        ...r
      }
    ),
    /* @__PURE__ */ e(C, { ...a, children: t })
  ] }) });
};
export {
  H as ColorIndicatorHeader,
  h as DEFAULT_COLOR_INDICATOR_HEADER_TESTID
};
//# sourceMappingURL=index.es637.js.map
